import { GUI } from "dat.gui";
import { Mesh, TextureLoader } from "three";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";
import { imgsTopic4 } from "../../../../../assets/imgs/Tema4/index";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import model from "../../../../../assets/models/subtopicthree/GLB_Monitor_V4.glb";

export class Monitor extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.listenersobserver();
		// this.helpers()
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Monitor = gltf.scene.getObjectByName("Monitor", true);
			this.Pantalla = gltf.scene.getObjectByName("Pantalla", true);
			this.Plano = gltf.scene.getObjectByName("Plano", true);
			this.initMonitor();
		});
	}

	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.Plano;
		object.material.map = newTexture
		object.material.toneMapped = false;
	}

	listenersobserver() {
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityTwo.showMonitor, () => {
			this.visible = true;
		});
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityTwo.hideMonitor, () => {
			this.visible = false;
		});
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityTwo.img1monitor, () => {
			this.updateMaterialScreen(imgsTopic4.monitorImg1Sub4Act2)
		});
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityTwo.img2monitor, () => {
			this.updateMaterialScreen(imgsTopic4.monitorImg2Sub4Act2)
		});
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFour.img3monitor, () => {
			this.updateMaterialScreen(imgsTopic4.monitorImg3Sub4Act4)
		});
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityFive.img4monitor, () => {
			this.updateMaterialScreen(imgsTopic4.monitorImg4Sub4Act5)
		});
		ObserverEmitter.on(EVENTS.tema4.subtopicFive.activityTwo.img5monitor, () => {
			this.updateMaterialScreen(imgsTopic4.monitorImg5Sub5Act2)
		});
	}

	initMonitor() {
		this.position.set(-11.4, -0.226, 2.7)
		this.rotation.y = 1.6
		this.scale.set(2, 2);
		this.Pantalla.scale.set(0.96, 1.2, 0.8) // monitor rectagular
		this.updateMaterialScreen(imgsTopic4.loginSub3Act2);
	}
	helpers() {
		const gui = new GUI();
		const folderMostrador = gui.addFolder("Monitor");
		const limit = 20;
		folderMostrador.add(this.scale, "x", -limit, limit).step(0.0001).name("Ancho");
		folderMostrador.add(this.scale, "y", -limit, limit).step(0.0001).name("Alto");

		folderMostrador.add(this.position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(this.position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(this.position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(this, "visible").name("Visible");

		folderMostrador
			.addColor({ color: this.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				this.material.color.set(value);
			});
	}
}
